import React, { FC } from "react"
import { TrackingEvent, trackEvent as trackEventGA } from "../../util"
import { css } from "@emotion/react"

export interface EventTrackerProps {
	event?: TrackingEvent | string
	events?: TrackingEvent[] | string[]
	data?: any
	children: React.ReactNode
	trackEvent?: (event: TrackingEvent | string, data?: any) => void
}

export const EventTracker: FC<EventTrackerProps> = ({
	event,
	events,
	data,
	children,
	trackEvent = trackEventGA,
}) => {
	const handleKeyDown = (
		keyEvent: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
	) => {
		if (keyEvent.key === "Enter" || keyEvent.key === " ") {
			keyEvent.preventDefault()
			onClickHandler()
		}
	}

	const onClickHandler = () => {
		if (event) {
			trackEvent(event, data)
		}

		if (Array.isArray(events)) {
			events.forEach((e) => trackEvent(e, data))
		}
	}

	return (
		<span
			css={styleEventTracker}
			role="button"
			tabIndex={0}
			onKeyDown={handleKeyDown}
			onClick={onClickHandler}
		>
			{children}
		</span>
	)
}

const styleEventTracker = css`
	cursor: pointer;
`
